import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@mui/styles";
import { colors, formatCurrency } from "common";
import { Theme, useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      marginTop: theme.spacing(1),
      height: 40,
      overflow: "hidden",
    },
    origPriceRow: {
      display: "flex",
      flexDirection: "row",
    },
    promoPriceTxt: {
      color: colors.primary,
      fontWeight: 600,
      fontSize: 18,
    },
    origPriceTxt: {
      color: colors.warning,
      fontWeight: 400,
      fontSize: 12,
      textDecoration: "line-through",
    },
    percentageTxt: {
      marginLeft: theme.spacing(0.5),
      color: colors.success,
      fontWeight: 600,
      fontSize: 12,
    },
    papansinPrice: {
      color: colors.grey[400],
      fontWeight: 400,
      fontSize: 12,
    },
  }),
  { index: 999 }
);

export const BuildsGalleryPrice = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {data && data.have_promo ? (
        <div>
          <Typography className={classes.promoPriceTxt}>
            {formatCurrency(data && data.amount ? data.amount : 0 || 0)}
          </Typography>
          <div className={classes.origPriceRow}>
            <Typography className={classes.origPriceTxt}>
              {formatCurrency(
                data && data.orig_amount ? data.orig_amount : 0 || 0
              )}
            </Typography>
            {data && data.discount_percentage ? (
              <Typography className={classes.percentageTxt}>
                {`-${data.discount_percentage}`}
              </Typography>
            ) : null}
          </div>
        </div>
      ) : (
        <div>
          <Typography className={classes.promoPriceTxt}>
            {formatCurrency(data && data.amount ? data.amount : 0 || 0)}
          </Typography>
        </div>
      )}
    </div>
  );
};
